import { Component } from '@angular/core'
import { FormsModule } from '@angular/forms'
import { FaIconComponent } from '@fortawesome/angular-fontawesome'

import { HrHiringNeed, RepositoryModal } from '../../../shared'

@Component({
    templateUrl: './hr-hiring-need.component.html',
    standalone: true,
    imports: [FormsModule, FaIconComponent],
})
export class HrHiringNeedComponent extends RepositoryModal<HrHiringNeed> {}
